import { Controller, useForm } from 'react-hook-form';
import { IBaseProjectResumeConfig } from '../models/projectResumeConfigModel';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import { useEffect } from 'react';
import { Button, Col, Form, FormGroup, Input, Row } from 'reactstrap';

interface Props {
  projectId: string;
  projectResumeConfig: IBaseProjectResumeConfig;
  handleForm: (form: IBaseProjectResumeConfig) => void;
  isUpdate?: boolean;
}

const InvestorProjectResumeConfigForm = ({
  handleForm,
  projectId,
  projectResumeConfig,
  isUpdate = false,
}: Props) => {
  const {
    handleSubmit,
    formState: { errors },
    control,
    reset,
    setValue,
  } = useForm<IBaseProjectResumeConfig>({
    resolver: yupResolver(
      yup
        .object({
          resume_area: yup
            .string()
            .nullable()
            .transform((value) => (value === '' ? null : value)),
          resume_square_rods: yup
            .string()
            .nullable()
            .transform((value) => (value === '' ? null : value)),
          resume_bathrooms: yup
            .string()
            .nullable()
            .transform((value) => (value === '' ? null : value)),
          resume_bedrooms: yup
            .string()
            .nullable()
            .transform((value) => (value === '' ? null : value)),
          resume_parking: yup
            .string()
            .nullable()
            .transform((value) => (value === '' ? null : value)),
          resume_description: yup
            .string()
            .nullable()
            .transform((value) => (value === '' ? null : value)),
        })
        .required(),
    ),
  });

  useEffect(() => {
    if (projectResumeConfig) {
      reset({
        resume_area: projectResumeConfig.resume_area,
        resume_square_rods: projectResumeConfig.resume_square_rods,
        resume_bathrooms: projectResumeConfig.resume_bathrooms,
        resume_bedrooms: projectResumeConfig.resume_bedrooms,
        resume_parking: projectResumeConfig.resume_parking,
        resume_description: projectResumeConfig.resume_description,
      });
    }
  }, [projectResumeConfig]);

  return (
    <Form role="form" onSubmit={handleSubmit(handleForm)}>
      <Row>
        <Col>
          <FormGroup>
            <label className="form-control-label" htmlFor="resume_area">
              Resumen area
            </label>
            <Controller
              name="resume_area"
              control={control}
              render={({ field }) => (
                <Input
                  className={errors.resume_area?.message && 'is-invalid'}
                  type="text"
                  placeholder="Ingresa resumen de area"
                  {...field}
                />
              )}
            />
          </FormGroup>
          <FormGroup>
            <label className="form-control-label" htmlFor="resume_square_rods">
              Resumen varas cuadradas
            </label>
            <Controller
              name="resume_square_rods"
              control={control}
              render={({ field }) => (
                <Input
                  className={errors.resume_square_rods?.message && 'is-invalid'}
                  type="text"
                  placeholder="Ingresa resumen de varas cuadradas"
                  {...field}
                />
              )}
            />
          </FormGroup>
          <FormGroup>
            <label className="form-control-label" htmlFor="resume_bathrooms">
              Resumen de baños
            </label>
            <Controller
              name="resume_bathrooms"
              control={control}
              render={({ field }) => (
                <Input
                  className={errors.resume_bathrooms?.message && 'is-invalid'}
                  type="text"
                  placeholder="Ingresa resumen de baños"
                  {...field}
                />
              )}
            />
          </FormGroup>
          <FormGroup>
            <label className="form-control-label" htmlFor="resume_bedrooms">
              Resumen habitaciones
            </label>
            <Controller
              name="resume_bedrooms"
              control={control}
              render={({ field }) => (
                <Input
                  className={errors.resume_bedrooms?.message && 'is-invalid'}
                  type="text"
                  placeholder="Ingresa resumen habitaciones"
                  {...field}
                />
              )}
            />
          </FormGroup>
          <FormGroup>
            <label className="form-control-label" htmlFor="resume_parking">
              Resumen parqueos
            </label>
            <Controller
              name="resume_parking"
              control={control}
              render={({ field }) => (
                <Input
                  className={errors.resume_parking?.message && 'is-invalid'}
                  type="text"
                  placeholder="Ingresa resumen de parqueos"
                  {...field}
                />
              )}
            />
          </FormGroup>
          <FormGroup>
            <label className="form-control-label" htmlFor="resume_description">
              Resumen de descripción
            </label>
            <Controller
              name="resume_description"
              control={control}
              render={({ field }) => (
                <Input
                  className={errors.resume_description?.message && 'is-invalid'}
                  type="textarea"
                  placeholder="Ingresa resumen de descripción"
                  {...field}
                />
              )}
            />
          </FormGroup>
          <Button color={isUpdate ? 'info' : 'success'}>
            {isUpdate ? 'Actualizar' : 'Crear'}
          </Button>
        </Col>
      </Row>
    </Form>
  );
};

export default InvestorProjectResumeConfigForm;
